/**
 * Boot Eigenaren Service - API calls voor boot-eigenaar koppelingen
 */

import apiFetch from './api';

export interface BootEigenaarCreate {
  boot_id: number;
  eigenaar_id: number;
  is_primair?: boolean;
  actief?: boolean;
}

export interface BootEigenaar {
  id: number;
  boot_id: number;
  eigenaar_id: number;
  is_primair: boolean;
  actief: boolean;
  created_at: string;
  updated_at?: string;
}

export const bootEigenarenService = {
  async remove(bootId: number, eigenaarId: number): Promise<void> {
    return apiFetch(`/api/v1/boot-eigenaren/remove?boot_id=${bootId}&eigenaar_id=${eigenaarId}`, {
      method: 'DELETE',
    });
  },

  async create(data: BootEigenaarCreate): Promise<BootEigenaar> {
    return apiFetch('/api/v1/boot-eigenaren', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
};
